import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/halloween';
import {setHalloweenModal} from '../../../../reducers/app/actions';
import TaskBg from './task_bg';
import SkeletonSVG from './skeleton';
import TicketSVG from './ticket';
import InfoSVG from './infosvg';

export default () => {
    const {halloween} = useSelector(Selector),
          dispatch = useDispatch();

    return (
        <div className="tasks">
            <div className="title">To participate, complete the tasks</div>
            <div className="tasks-list">
                <div className={`h-task ${halloween.referrals >= 3 ? 'active' : ''}`} onClick={e => dispatch(setHalloweenModal('friends'))}>
                    <div className="task-content">
                        <div className="left">
                            <div className="name">
                                <SkeletonSVG />
                                <span>Invite <b>3</b> friends with deposit</span>
                                <InfoSVG />
                            </div>
                            <div className="progress-block">
                                <div className={`progress ${halloween.referrals > 0 ? 'active' : ''}`}></div>
                                <div className={`progress ${halloween.referrals > 1 ? 'active' : ''}`}></div>
                                <div className={`progress ${halloween.referrals > 2 ? 'active' : ''}`}></div>
                            </div>
                        </div>
                        <div className="right">
                            {halloween.referrals >= 3 ? (
                                <div className="icon">
                                    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.80039 13C6.50039 13 6.30039 12.9 6.10039 12.7L1.20039 7.49997C0.800391 7.09997 0.800391 6.49997 1.20039 6.09997C1.60039 5.69997 2.20039 5.69997 2.60039 6.09997L6.70039 10.5L15.1004 1.29997C15.4004 0.899971 16.1004 0.79997 16.5004 1.09997C16.9004 1.39997 17.0004 2.09997 16.7004 2.49997L16.6004 2.59997L7.50039 12.6C7.40039 12.9 7.10039 13 6.80039 13Z" fill="#199E19"/>
                                    </svg>
                                </div>
                            ) : (
                                <div className="icon">
                                    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.5" d="M11.24 1H4.76004C1.00004 1 0.710038 4.38 2.74004 6.22L13.26 15.78C15.29 17.62 15 21 11.24 21H4.76004C1.00004 21 0.710038 17.62 2.74004 15.78L13.26 6.22C15.29 4.38 15 1 11.24 1Z" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            )}
                        </div>
                    </div>
                    <TaskBg />
                </div>

                <div className={`h-task ${halloween.tickets >= 25 ? 'active' : ''}`} onClick={e => dispatch(setHalloweenModal('tickets'))}>
                    <div className="task-content">
                        <div className="left">
                            <div className="name">
                                <TicketSVG />
                                <span>Earn <b>25</b> tickets</span>
                                <InfoSVG />
                            </div>
                            <div className="progress-block">
                                <div className="progress">
                                    <div className="progress-line" style={{
                                        width: `${(halloween.tickets / 25) * 100}%`
                                    }}></div>
                                </div>
                            </div>
                        </div>
                        <div className="right">
                            {halloween.tickets >= 25 ? (
                                <div className="icon">
                                    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.80039 13C6.50039 13 6.30039 12.9 6.10039 12.7L1.20039 7.49997C0.800391 7.09997 0.800391 6.49997 1.20039 6.09997C1.60039 5.69997 2.20039 5.69997 2.60039 6.09997L6.70039 10.5L15.1004 1.29997C15.4004 0.899971 16.1004 0.79997 16.5004 1.09997C16.9004 1.39997 17.0004 2.09997 16.7004 2.49997L16.6004 2.59997L7.50039 12.6C7.40039 12.9 7.10039 13 6.80039 13Z" fill="#199E19"/>
                                    </svg>
                                </div>
                            ) : (
                                <div className="icon">
                                    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.5" d="M11.24 1H4.76004C1.00004 1 0.710038 4.38 2.74004 6.22L13.26 15.78C15.29 17.62 15 21 11.24 21H4.76004C1.00004 21 0.710038 17.62 2.74004 15.78L13.26 6.22C15.29 4.38 15 1 11.24 1Z" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            )}
                        </div>
                    </div>
                    <TaskBg />
                </div>
            </div>

            <div className="participate">
                
            </div>
        </div>
    )
}